<template>
    <div class="animated fadeIn">
      <div class="title font-300 font-24 mb-15">
        {{this.$route.name}}
      </div>
      <div class="box">
        <div class="p-15 pb-0">
          <div class="row">
            <div class="col-6">
              <a @click="openPage('/vouchers')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
            </div>
          </div>
        </div>
        <hr class="mb-0">
        <div class="p-15 pt-0">
          <div class="row justify-content-center mt-30">
            <div class="col-sm-10">
              <form @submit.prevent="validateRegister">
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label for="name_banner">Name</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="name_banner" v-model="name_voucher" name="name" v-validate="'required'" type="text"></b-form-input>
                    <span class="error">{{ errors.first('name') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label for="name_banner">Amount</label>
                  </b-col>
                  <b-col sm="10">
                    <money
                      class="form-control"
                      v-model="amount"
                      v-bind="money2"
                    ></money>
                    <span class="error">{{ errors.first('amount') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label for="url_banner">Description</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="url_banner" v-model="description" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label for="image_banner">Banner</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-file name="file" v-validate="'required'" @change="previewImage" accept="image/*" v-model="file" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                    <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                    <div class="image-preview" v-if="imageData.length > 0">
                        <img class="preview" :src="imageData">
                    </div>
                    <span class="error">{{ errors.first('file') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label for="image_banner">Is Rewards</label>
                  </b-col>
                  <b-col sm="10">
                    <div>
                      <b-form-select name="is_rewards" v-validate="'required'" v-model="selected" :options="options" class="mb-3" />
                    </div>
                    <span class="error">{{ errors.first('is_rewards') }}</span>
                  </b-col>
                </b-row>
                <div class="text-right">
                  <button type="submit" class="btn-primary">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { Auth } from '@/api'
  
  export default {
    name: 'addSlideBanner',
    data: function () {
      return {
        messageError: 'data saved successfully!',
        titleMessageError: 'Success',
        notificationSystem: {
          options: {
            success: {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            }
          }
        },
        name_voucher: '',
        amount: 0,
        description: '',
        imageData: '',
        file: null,
        url: '',
        selected: 0,
        options: [
          { value: 0, text: 'No' },
          { value: 1, text: 'Yes' }
        ],
        money: {
          decimal: ",",
          thousands: ".",
          prefix: "",
          suffix: "",
          precision: 0,
          masked: false
        },
        money2: {
          decimal: ",",
          thousands: ".",
          prefix: "IDR ",
          suffix: "",
          precision: 2,
          masked: false
        }
      }
    },
    methods: {
      validateRegister () {
        this.$validator.validateAll().then((result) => {
          if(result) {
            axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
            axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
            var data = new FormData()
            data.append('photos', this.file)
            data.append('amount_voucher', this.amount)
            data.append('is_reward', this.selected)
            data.append('description', this.description)
            data.append('name', this.name_voucher)
  
  
            // eslint-disable-next-line no-unused-vars
            axios.put('crm/v1/voucher/'+(this.$route.query.id), data).then(response => {
              // console.log('test', response)
              this.$router.push('/vouchers')
              this.$toast.success('data saved successfully!', 'Success', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            // eslint-disable-next-line no-unused-vars
            }).catch(error => {
              // console.log('error', error)
              this.$toast.success('cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            })
          } else {
            this.$toast.success('please fill in required fields!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }
        })
      },
      openPage (event) {
        this.$router.push(event)
      },
      previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
      },
      fetchData() {
        // this.$route.query.id
        axios.get('crm/v1/voucher/'+(this.$route.query.id)).then(response => {
            this.file = response.data.data.thumbnail
            this.description = response.data.data.description
            this.name_voucher = response.data.data.name
            this.selected = response.data.data.is_reward
            this.amount = response.data.data.voucher_amount
            this.imageData = Auth.apiUrl + 'crm/v1/img/voucher/' + response.data.data.thumbnail
      }).catch(error => {
        console.log('error', error)
      })
      }
    },
    created() {
        this.fetchData()
    }
  }
  </script>
  
  <style>
  </style>
  